/* Compra rápida de la tarjeta de producto (snippets/product-card.liquid, show_quick_add). */
if (!customElements.get('vb-quick-add')) {
  customElements.define('vb-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;
      this.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-variant-id]');
        if (!btn || btn.disabled || !window.VB?.cart) return;
        e.preventDefault();
        btn.classList.add('is-loading');
        try {
          await VB.cart.add([{ id: Number(btn.dataset.variantId), quantity: Math.max(1, Number(btn.dataset.quantity) || 1) }]);
        } catch (err) {
          console.error(err);
        } finally {
          btn.classList.remove('is-loading');
        }
      });
    }
  });
}

/* Descuentos de pack · misma regla que snippets/vb-pack-price.liquid y la Discount Function: pack de k uds = precio real × k
   × (1 − %), a ,99 si el mapa trae «|99»; total de q uds = mejor pack de q o menos + sueltas a precio unitario (nunca más
   que q × unidad). Mapa «2:17,3:28|99» (unidades:%) o «2:=3499» (unidades:=total fijo en céntimos, gana al %). La usan también la ficha y «Un ritual» de la Home.
   Siempre se define aquí (sin «||»): una versión vieja en caché no puede quedarse con el formato de importes fijos. */
window.VBPacks = {
  parse: (s) => {
    const [p, f] = String(s || '').split('|');
    const m = String(p || '').split(',').map((x) => { const [q, v] = x.split(':'); return String(v || '')[0] === '=' ? [Number(q), 0, Number(v.slice(1))] : [Number(q), Number(v)]; }).filter(([q, d, t]) => q > 0 && (t > 0 || (d > 0 && d < 100)));
    m.r99 = f === '99';
    return m;
  },
  /* precio de UN pack de k unidades con el % d: céntimo exacto o ,99 (igual que el Liquid y la Function) */
  pack: (k, d, unit, r99, t0) => {
    const base = k * unit;
    if (t0 > 0) return t0 < base ? t0 : base;
    let t = base - Math.round((base * d) / 100);
    if (r99) t = Math.round(t / 100) * 100 - 1;
    return t < base ? t : base;
  },
  total: (map, q, unit) => map.reduce((b, [kq, d, t]) => (kq <= q ? Math.min(b, VBPacks.pack(kq, d, unit, map.r99, t) + (q - kq) * unit) : b), q * unit),
};

/* Unidades de la tarjeta (1 · 2 · 3): selección visual + etiqueta «N ud/uds». Delegado: sirve también tras re-renders AJAX. */
if (!window.__vbCardUnits) {
  window.__vbCardUnits = true;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-vb-card-unit]');
    if (!b) return;
    e.preventDefault();
    const box = b.closest('.vb-card__units');
    box.querySelectorAll('[data-vb-card-unit]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
    // Cambio de texto con transición suave: el valor nuevo entra desde abajo con un leve desenfoque
    const swap = (el, txt) => {
      if (!el || el.textContent === txt) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || document.hidden || !el.animate) { el.textContent = txt; return; }
      // El texto cambia YA (nunca depende de que termine una animación) y solo se anima su entrada
      el.getAnimations().forEach((a) => a.cancel());
      el.textContent = txt;
      el.animate([{ opacity: 0, transform: 'translateY(40%)', filter: 'blur(2px)' }, { opacity: 1, transform: 'none', filter: 'blur(0)' }], { duration: 320, easing: 'cubic-bezier(.22, 1, .36, 1)' });
    };
    const lab = box.querySelector('[data-vb-card-unit-label]');
    if (lab) { const n = b.dataset.vbCardUnit; swap(lab, b.dataset.label || `${n} ${n === '1' ? lab.dataset.one : lab.dataset.many}`); }
    /* la cantidad elegida viaja al quick-add y a la ficha (?cantidad=N) */
    const card = b.closest('.vb-card') || box.parentElement;
    const n = Math.max(1, parseInt(b.dataset.vbCardUnit, 10) || 1);
    card.querySelectorAll('[data-variant-id]').forEach((x) => { x.dataset.quantity = n; });
    /* con descuentos de pack (o su vista previa), el precio de la tarjeta = total del pack elegido */
    /* mapa solo de vista previa (descuentos apagados): únicamente en un tema sin publicar */
    const role = window.Shopify && Shopify.theme && Shopify.theme.role;
    const pr = [...card.querySelectorAll('[data-vb-pack-map]')].find((x) => !x.hasAttribute('data-vb-pack-preview') || (role && role !== 'main'));
    if (pr) {
      const fm = (c) => (window.VB && VB.formatMoney ? VB.formatMoney(c) : `${(c / 100).toFixed(2).replace('.', ',')} €`);
      const unit = Number(pr.dataset.unit || 0);
      const cmp = Number(pr.dataset.cmp || 0);
      const now = VBPacks.total(VBPacks.parse(pr.dataset.vbPackMap), n, unit);
      const was = (cmp > unit ? cmp : unit) * n;
      const nowEl = pr.querySelector('[data-vb-card-now]');
      if (nowEl) swap(nowEl, fm(now));
      let s = pr.querySelector('.vb-card__compare');
      if (pr.dataset.showCmp === 'true' && was > now) {
        if (!s) { s = document.createElement('s'); s.className = 'vb-card__compare'; pr.prepend(s); }
        s.textContent = fm(was);
        s.style.display = '';
      } else if (s) s.style.display = 'none';
    }
    card.querySelectorAll('a.vb-card__media, a.vb-card__link').forEach((a) => {
      const u = new URL(a.href, location.origin);
      if (n > 1) u.searchParams.set('cantidad', n); else u.searchParams.delete('cantidad');
      a.href = u.pathname + u.search;
    });
  });
}

/* Favoritos · corazón de la tarjeta y de la ficha ([data-vb-fav-toggle]=id de producto). Mismo almacén y evento que ya leen
   /pages/favoritos (section-vb-favorites.js) y el contador de la cabecera (section-vb-header.js): localStorage «vb:favs»
   (IDs en texto, orden de guardado) + «vb:favs:changed» {detail: lista}. Sincroniza todos los corazones del mismo producto,
   anuncia «Guardado / Eliminado» en una región viva (.vb-toast) y no navega (botón fuera del enlace de la tarjeta). */
if (!window.__vbFavToggle) {
  window.__vbFavToggle = true;
  const KEY = 'vb:favs';
  const read = () => { try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? [...new Set(v.map(String))] : []; } catch (_) { return []; } };
  const sync = (list) => {
    const l = list || read();
    document.querySelectorAll('[data-vb-fav-toggle]').forEach((b) => {
      const on = String(l.includes(b.dataset.vbFavToggle));
      if (b.getAttribute('aria-pressed') !== on) b.setAttribute('aria-pressed', on);
    });
  };
  let toast = null;
  let toastT = 0;
  const ensureToast = () => {
    if (toast && toast.isConnected) return toast;
    toast = document.createElement('div');
    toast.className = 'vb-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.append(toast);
    return toast;
  };
  const say = (msg, icon) => {
    if (!msg) return;
    const t = ensureToast();
    clearTimeout(toastT);
    t.textContent = '';
    requestAnimationFrame(() => {
      if (icon) { const ic = icon.cloneNode(true); ic.removeAttribute('class'); ic.setAttribute('aria-hidden', 'true'); t.append(ic); }
      t.append(document.createTextNode(msg));
      t.classList.add('is-on');
      toastT = setTimeout(() => t.classList.remove('is-on'), 2400);
    });
  };
  /* Al guardar, «el alma» del producto vuela al corazón del header (Nicolas 28-oct): una copia de la foto se desprende,
     se convierte en una esfera luminosa y recorre una curva hasta el icono, con una estela de destellos detrás; el corazón
     del header la recibe con un latido y un halo. Solo transform/opacity/filter (WAAPI); nada con «reducir movimiento». */
  const fly = (from) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const to = [...document.querySelectorAll('.vb-header__fav')].find((x) => x.getClientRects().length);
    if (!to || !from.animate) return;
    const scope = from.closest('.vb-card') || from.closest('.shopify-section') || document;
    const img = [...scope.querySelectorAll('img')].find((x) => x.getClientRects().length && x.getBoundingClientRect().width > 60 && getComputedStyle(x).opacity !== '0');
    const z = to.getBoundingClientRect();
    let r = img ? img.getBoundingClientRect() : from.getBoundingClientRect();
    if (!r.width || !z.width) return;
    // la foto entera puede ser enorme (galería de la ficha): el alma sale de un cuadrado centrado de máx. 160 px
    const size = Math.min(160, r.width, r.height);
    const sx = r.left + r.width / 2, sy = r.top + r.height / 2, ex = z.left + z.width / 2, ey = z.top + z.height / 2;
    const dx = ex - sx, dy = ey - sy;
    const cx = dx * 0.25 + (dx >= 0 ? -60 : 60), cy = Math.min(dy, 0) * 0.5 - 140; // punto de control de la curva (sube y se abre)
    const at = (t) => [2 * (1 - t) * t * cx + t * t * dx, 2 * (1 - t) * t * cy + t * t * dy];
    const layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;inset:0;z-index:2147483646;pointer-events:none;overflow:hidden';
    document.body.appendChild(layer);
    const soul = document.createElement('span');
    soul.style.cssText = `position:absolute;left:${sx - size / 2}px;top:${sy - size / 2}px;width:${size}px;height:${size}px;border-radius:24px;background:#f6e4e1 center/cover no-repeat;${img ? `background-image:url("${(img.currentSrc || img.src).replace(/"/g, '%22')}")` : ''};box-shadow:0 0 0 0 rgba(122,34,51,0);will-change:transform,opacity,filter`;
    layer.appendChild(soul);
    const N = 14, frames = [];
    for (let k = 0; k <= N; k++) {
      const t = k / N, [x, y] = at(t);
      const lift = t < 0.18 ? t / 0.18 : 1; // primero se despega (sube un poco y se redondea)
      const sc = t < 0.18 ? 1 - 0.12 * lift : 0.88 - 0.8 * ((t - 0.18) / 0.82) ** 0.9;
      frames.push({
        transform: `translate(${x}px, ${y - 14 * lift * (1 - t)}px) scale(${Math.max(sc, 0.06)}) rotate(${-8 * t}deg)`,
        opacity: t < 0.12 ? 0.35 + t / 0.12 * 0.6 : 0.95 - 0.55 * t,
        filter: `blur(${(t * 3.5).toFixed(2)}px) saturate(${1 + t * 0.6}) brightness(${1 + t * 0.35})`,
        borderRadius: t < 0.2 ? `${24 + t / 0.2 * 26}%` : '50%',
        boxShadow: `0 0 ${Math.round(10 + 40 * t)}px ${Math.round(6 * t)}px rgba(122,34,51,${(0.15 + 0.5 * t).toFixed(2)})`,
      });
    }
    const DUR = 1050, EASE = 'cubic-bezier(.45, 0, .2, 1)';
    const anim = soul.animate(frames, { duration: DUR, easing: EASE, fill: 'forwards' });
    // estela: destellos que siguen la misma curva un poco por detrás
    const sparkFrames = (k) => Array.from({ length: N + 1 }, (_, i) => {
      const t = i / N, [x, y] = at(t);
      return { transform: `translate(${x}px, ${y}px) scale(${(1 - t * 0.6) * (1 - k * 0.15)})`, opacity: t < 0.15 ? 0 : (0.85 - t * 0.5) * (1 - k * 0.18) };
    });
    for (let k = 0; k < 5; k++) {
      const d = document.createElement('i');
      const s2 = 9 - k;
      d.style.cssText = `position:absolute;left:${sx - s2 / 2}px;top:${sy - s2 / 2}px;width:${s2}px;height:${s2}px;border-radius:50%;background:${k % 2 ? '#f6e4e1' : '#7a2233'};box-shadow:0 0 10px 2px rgba(122,34,51,.45)`;
      layer.appendChild(d);
      d.animate(sparkFrames(k), { duration: DUR, delay: 70 + k * 55, easing: EASE, fill: 'both' });
    }
    let ended = false;
    const end = () => {
      if (ended) return;
      ended = true;
      layer.remove();
      to.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35) rotate(-6deg)' }, { transform: 'scale(.9) rotate(3deg)' }, { transform: 'scale(1)' }], { duration: 560, easing: 'cubic-bezier(.22, 1, .36, 1)' });
      to.animate([{ boxShadow: '0 0 0 0 rgba(122,34,51,.45)' }, { boxShadow: '0 0 0 14px rgba(122,34,51,0)' }], { duration: 650, easing: 'ease-out' });
    };
    const kill = setTimeout(end, DUR + 500); // por si el navegador no avisa del final (pestaña en segundo plano)
    anim.onfinish = () => { clearTimeout(kill); end(); };
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-vb-fav-toggle]');
    if (!b) return;
    e.preventDefault();
    const id = b.dataset.vbFavToggle;
    const list = read();
    const i = list.indexOf(id);
    const on = i === -1;
    if (on) list.push(id); else list.splice(i, 1);
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (_) {}
    sync(list);
    b.classList.remove('is-pop');
    if (on && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) { void b.offsetWidth; b.classList.add('is-pop'); }
    if (on) fly(b);
    say(on ? b.dataset.msgOn : b.dataset.msgOff, on ? b.querySelector('svg') : null);
    document.dispatchEvent(new CustomEvent('vb:favs:changed', { detail: list }));
  });
  document.addEventListener('animationend', (e) => { if (e.target.classList && e.target.classList.contains('is-pop')) e.target.classList.remove('is-pop'); });
  document.addEventListener('vb:favs:changed', (e) => sync(Array.isArray(e.detail) ? e.detail.map(String) : null));
  window.addEventListener('storage', (e) => { if (e.key === KEY || e.key === null) sync(); });
  window.addEventListener('pageshow', () => sync());
  document.addEventListener('shopify:section:load', () => sync());
  /* tarjetas que llegan por AJAX (buscador, filtros, carrito): una pasada por frame */
  let raf = 0;
  new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; sync(); }); }).observe(document.documentElement, { childList: true, subtree: true });
  const init = () => { ensureToast(); sync(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}
